import clsx from 'clsx'
import React, { useMemo, useState } from 'react'
import { MediaMobile, MediaTablet } from '../../../api/const/MediaQuery'
import useMediaQuery from '../../../hook/useMediaQuery'


import { ChevronDown, InfoTooltip, TimedTooltip } from '../../atoms'
import { BillingListData } from 'components/types/types'


interface iBillingsAccordionBody {
  data?: BillingListData[]

}

export const BillingsAccordionBody = ({ data }: iBillingsAccordionBody) => {
  const [selectedId, setSelectedId] = useState<string>('')
  const mobile = useMediaQuery(MediaMobile)
  const tablet = useMediaQuery(MediaTablet)

  const showBody = useMemo(() => {
    if (data && data?.length !== 0) {

      return (
        data?.map((el, index) => {

          return (
            <div key={index} className='d-flex tableBillingsBody flex-column'>
              <div className='d-flex w-100  pb-3 pt-3  ' id={index.toString()}>
                <p className={clsx("corporates m-0 p-0  ",
                  { "w-85 ps-3": !mobile },
                  { "w-70 ps-0": mobile })}>{el.month} {el.year}</p>
                {el.billingMonthInfos?.length !== 0 ?
                  <div className={clsx(" justify-content-end billingsActions d-flex ",
                    { "close": selectedId === index.toString() },
                    { "w-15 pe-3 taejustify-content-end": !tablet },
                    { "w-30 tac justify-content-center": tablet },
                  )}
                    onClick={() => {
                      index.toString() === selectedId ? setSelectedId('') : setSelectedId(index.toString())
                    }}>
                    <p className='p-0 m-0'>
                      {el.planTitle}
                    </p>

                    <div>
                      <ChevronDown className='openRow' />
                    </div>
                  </div>
                  :
                  <div className='billingsActions w-50  pe-2 justify-content-between d-flex'>
                    <div className=''>
                      {el.planTitle}
                    </div>

                    <div className='w-100  d-flex justify-content-end'>
                      <TimedTooltip

                        text="You don't have any bills yet..."
                        icon={<InfoTooltip className='accordionTooltip'></InfoTooltip>} />

                    </div>
                  </div>
                }
              </div>
              {selectedId === index.toString() &&
                <div className=' billingsBg pt-2 pb-4'>

                  {el.billingMonthInfos ? el.billingMonthInfos.map((meeting) => {
                    return (
                      <div className={clsx('d-flex  w-100 m-0 p-0   tablePadding billingsInnerTr',
                        { "flex-row align-items-center justify-content-between  pb-3 pt-3": !mobile },
                        { "flex-row justify-content-center align-items-center  pb-2 pt-2": mobile })}
                        key={index + "body" + el.year + el.month + el.planId}>
                        <p className={clsx(' text-uppercase   m-0 p-0 ',
                          { "ps-3 pe-3 ": !mobile },
                          {"w-70 ps-1 ":mobile})} > {meeting.meetingDate} - {meeting.companyName}
                        </p>
                        <p className={clsx('  d-flex m-0 p-0  fw-700 align-items-center ',
                          { "w-30 justify-content-end": mobile },
                          { "pe-3 ": !mobile })}>
                          {meeting.price ? meeting.price + ',00€' : 'included'}
                        </p>
                      </div>
                    )
                  }) : <div></div>}

                </div>
              }


            </div>
          )
        })
      )
    } else {
      return (
        <div className='d-flex tableBillingsBody flex-column'>
          <div className='d-flex justify-content-start align-items-center p-3 m-0 '>
            <p className='m-0 p-0'>You don't have any bills yet...</p>
          </div>
        </div>
      )
    }



  }, [selectedId, data])


  return (
    <>
      {showBody}
    </>
  )
}
